// these match the graph
var SummaryType;
(function (SummaryType) {
    SummaryType["COMMENTS"] = "comments";
    SummaryType["RECOGNITIONS"] = "recognitions";
    SummaryType["TROPHIES"] = "trophies";
})(SummaryType || (SummaryType = {}));
export default SummaryType;
